import {
  Container,
  VStack,
  Card,
  Button,
  HStack,
  Text,
} from "@chakra-ui/react";
import { useUsers } from "../../providers/UsersProvider";
import { Link } from "react-router-dom";
import moment from "moment";

export default function AdminMembers() {
  var { adminMembers } = useUsers();

  const handleExport = () => {
    if (!adminMembers || adminMembers.length === 0) return;

    const csvRows = [];
    const ignoreKeys = [
      "created_at",
      "updated_at",
      "member_id",
      "member_location",
    ];

    // Flatten and clean data
    const flattenedData = adminMembers.map((item) => {
      const entry = {};

      // Members data
      Object.entries(item.members).forEach(([key, value]) => {
        if (ignoreKeys.includes(key)) return;

        let finalValue = value;
        if (
          ["expiry_date", "enrollment_date", "date_of_birth"].includes(key) &&
          value
        ) {
          finalValue = moment(value).format("YYYY-MM-DD");
        }

        entry[`member_${key}`] = finalValue;
      });

      // Locations data
      Object.entries(item.locations).forEach(([key, value]) => {
        if (key === "created_at" || key === "updated_at") return;
        entry[`location_${key}`] = value;
      });

      return entry;
    });

    if (flattenedData.length === 0) return;

    const headers = Object.keys(flattenedData[0]);
    csvRows.push(headers.join(","));

    for (const row of flattenedData) {
      const values = headers.map((header) => {
        const val =
          row[header] === null || row[header] === undefined ? "" : row[header];
        const escaped = ("" + val).replace(/"/g, '""');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(","));
    }

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `members_export_${moment().format("YYYY-MM-DD")}.csv`,
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container p="4" maxW="8xl">
      <VStack width="100%" spacing={4}>
        <Card borderRadius="md" p="4" width={"100%"}>
          <HStack justifyContent="space-between" w="100%">
            <Text fontWeight="600" className="customfont" fontSize="2xl">
              Members
            </Text>

            <HStack spacing="3">
              <Button onClick={handleExport} colorScheme="green">
                Export
              </Button>
            </HStack>
          </HStack>
        </Card>

        <Card width={"100%"}>
          <table>
            <thead>
              <tr>
                <th py="4" fontSize="sm">
                  Id
                </th>
                <th py="4" fontSize="sm">
                  Plan
                </th>
                <th py="4" fontSize="sm">
                  Name
                </th>
                <th py="4" fontSize="sm">
                  Number
                </th>
                <th py="4" fontSize="sm">
                  Email
                </th>
                <th py="4" fontSize="sm">
                  Aadhar/Pan
                </th>
                <th py="4" fontSize="sm">
                  Store
                </th>
                <th py="4" fontSize="sm">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {adminMembers.map((u, idx) => {
                return (
                  <tr key={idx}>
                    <td py="4" fontSize="sm">
                      {u.members.id_number}
                    </td>
                    <td py="4" fontSize="sm">
                      {" "}
                      {u.members.scheme_name}
                    </td>
                    <td py="4" fontSize="sm">
                      {" "}
                      {u.members.name}
                    </td>
                    <td py="4" fontSize="sm">
                      {" "}
                      {u.members.phone}
                    </td>
                    <td py="4" fontSize="sm">
                      {" "}
                      {u.members.e_mail}
                    </td>
                    <td py="4" fontSize="sm">
                      {" "}
                      {u.members.user_id_no}
                    </td>
                    <td py="4" fontSize="sm">
                      {" "}
                      {u.locations.name}
                    </td>
                    <td py="4" fontSize="sm">
                      <HStack>
                        {/* <Link to='/users/edit' state={u} >
                                                    <Button colorScheme='whatsapp'>Edit</Button>
                                                </Link> */}

                        <Link to="/users/delete" state={u["members"]}>
                          <Button colorScheme="red">Delete</Button>
                        </Link>

                        <Button colorScheme="purple" w="98%">
                          <Link
                            to="/users/memberships/installments"
                            state={u["members"]}
                          >
                            Installments
                          </Link>
                        </Button>
                      </HStack>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Card>
      </VStack>
    </Container>
  );
}
